import gsx from 'styles'

const styles = {
  root: {
    overflowy: { sm: 'auto' },
    overflowx: 'hidden',
    height: { xs: 'auto', md: '700px' },
    '& ::-webkit-scrollbar, ::-webkit-scrollbar-thumb': {
      display: { xs: 'none' },
    },
  },

  containerMobile: {
    backgroundColor: 'background.grey',
  },

  googleReviewsContainer: {
    backgroundColor: 'background.grey',
    py: 3,
    '& > .MuiGrid-container': {
      ...gsx.googleReviewsContainer,
      marginTop: 3,
    },
  },

  '& iframe': {
    borderTopLeft: 2,
  },

  // firstQuoter: {
  //   'MuiGrid2-container'
  // },

  // quoterContainer: {
  //   paddingX: { xs: '0px!important', lg: 'unset' },
  //   '& .MuiGrid2-container': {
  //     padding: '0px!important',
  //   },
  //   '& .MuiAutocomplete-root': {
  //     marginBottom: (theme) => theme.spacing(2),
  //     '&:first-of-type': {
  //       marginRight: { lg: 1 },
  //     },
  //   },
  //   '& .MuiGrid2-root': {
  //     '&:last-of-type': {
  //       marginTop: 0,
  //       paddingTop: 0,
  //     },
  //   },
  // },

  quoterFirstContainer: {
    paddingX: { xs: '0px!important', lg: 'unset' },
    '& .MuiGrid2-container': {
      padding: '0px!important',
    },
    '& .MuiAutocomplete-root': {
      marginBottom: (theme) => theme.spacing(2),
      '&:first-of-type': {
        marginRight: { lg: 1 },
      },
    },
    '& .MuiGrid2-root': {
      '&:last-of-type': {
        marginTop: 0,
        paddingTop: 0,
      },
    },
  },

  quoterContainer: {
    paddingX: { xs: '0px!important', lg: 'unset' },
    '& .MuiTypography-root': {
      mb: 0,
    },
    '& .MuiGrid2-container': {
      padding: '0px!important',
    },
    '& .MuiButton-root': {
      padding: '0px!important',
    },
  },

  imageSwiper: {
    '& .swiper': {
      width: '100%',
      height: {
        xs: 300, md: 250, lg: 364, xl: 364,
      },
    },
    pl: { xs: 0, sm: 0.5 },
    pr: { xs: 0, sm: 0.5 },
    mb: { xs: 2, sm: 0 },
  },

  firstQuoterContainer: {

  },

  ratingComponent: {
    '& .MuiGrid-container': {
      // mb: { xs: 0, md: 1 },
      // backgroundColor: 'transparent',
    },
  },

  internalContainer: {
    '&.MuiGrid2-container': {
      marginBottom: '0px!important',
    },
    '& .MuiPaper-root': {
      background: { md: 'white' },
      border: { md: '1px solid #F1F1F1' },
      borderRadius: '2px',
    },
  },

  mainContainer: {
    '&.Main-Banner-Container-root': {
      paddingBottom: { xs: 2, lg: 0 },
      backgroundColor: 'common.secondaryEasy',
    },
    '& .MuiTypography-description': {
      color: 'secondary.main',
    },
  },
  mainContainerABTest: {
    '&.Main-Banner-Container-root': {
      paddingTop: { xs: 2, lg: 0 },
      paddingBottom: { xs: 2, lg: 0 },
      paddingRight: { xs: 2, lg: 0 },
      backgroundColor: 'background.grey',
    },
  },

  timelineContainer: {
    '& .Timeline-Container-root': {
      paddingY: { lg: 6 },
      paddingX: { lg: 10 },
    },
  },

  internalContainerEasy: {
    '& .MuiPaper-root': {
      borderRadius: '2px',
    },
  },

  linearGradient: {
    background: {
      lg: 'linear-gradient(to bottom, #fff 0%, #fff 25%, #f7f9fb 25%, #f7f9fb 80%, #fff  80%, #fff 100%)',
    },
  },
}

export default styles
